import { HelprerContentItem } from "../../../../types/propsTypes";

export const skillHelpers = {
    pageTitle: [
        {
            type: 'title',
            text: 'Фактор курса'
        },
        'Навыки, приобретаемые в процессе обучения. Отобажается на странице курса',
        {
            type: 'image',
            imgSrc: '/static/img/helper/page-title/skill.jpg',
        }
    ] as HelprerContentItem[]
}